/**
 * ============================================================
 * AUTH REQUEST INTERCEPTOR
 * ============================================================
 * Automatically attaches Authorization header to EVERY request
 *
 * ✅ FIXES: Race conditions where requests fire before auth headers exist
 * ✅ GUARANTEES: Token is attached at request time, not initialization time
 * ✅ ELIMINATES: Manual token passing in every API call
 *
 * This runs BEFORE every axios request is sent.
 * ============================================================
 */

import api from "./client";

api.interceptors.request.use(
  (config) => {
    // For FormData uploads, never force JSON content-type.
    // The browser must set multipart boundary automatically.
    if (typeof FormData !== "undefined" && config?.data instanceof FormData) {
      if (config.headers) {
        delete config.headers["Content-Type"];
        delete config.headers["content-type"];
      }
    }

    // Get token fresh from localStorage RIGHT before request
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log("🔐 [Auth] Token attached to request:", config.url);
    } else {
      console.warn("⚠️ [Auth] No token found for request:", config.url);
    }

    return config;
  },
  (error) => {
    console.error("❌ [Auth] Request interceptor error:", error);
    return Promise.reject(error);
  }
);

console.log("✅ [Auth] Request interceptor initialized");

export default api;
